module.exports = __webpack_public_path__ + "img/as_app_mac.5f4c165b.png";